<template>
	<div class="recharge-page   page-padding-top">
		<top-bar :title="i18n.t('recharge.title')" @back="back"></top-bar>

		<div class="recharge-main">
			<div class="title">{{$t('recharge.label1')}}</div>
			<div class="recharge-list">
				<div class="list flex-center" @click="chooseRecharge">
					<div class="name flex-1 flex-center-start">
						<img :src="rechargeInfo.icon" alt="">
						<span>{{rechargeInfo.name}}</span>
					</div>
					<div class="check">
						<img :src="rightUrl" alt="">
					</div>
				</div>
			</div>

			<div class="address-box">
				<div class="qrcode flex-center" >
					<div ref="qrcode" id="qrcode"></div>
				</div>
				<div class="label">{{i18n.t('recharge.label2')}}</div>
				<div class="address flex-center-between">
					<div class="info flex-1">{{address}}</div>
					<div class="flex-center-end  copy-icon" @click="copyData">
						<img :src="copyUrl" alt="">
					</div>
				</div>

				<div class="warning">{{ getCurrentCurrencyWarning() }}</div>
			</div>


			<div class="recharge-warning">
				<div class="title">{{i18n.t('recharge.label4')}}</div>
				<div class="info">{{ $t('recharge.desc1', [rechargeInfo.name]) }}</div>
				<div class="info">{{ $t('recharge.desc2', [rechargeInfo.min]) }}</div>
				<div class="info">{{$t('recharge.desc3')}}</div>
			</div>

			<!-- 充值申请表单 -->
			<div class="recharge-application">
				<div class="application-title">{{ i18n.t('recharge.chong_zhi_shen_qing') }}</div>
				<div class="form-content">
					<div class="form-item">
						<div class="label">{{ i18n.t('recharge.chong_zhi_shu_liang') }}</div>
						<input
							type="text"
							v-model="applyForm.amount"
							:placeholder="i18n.t('recharge.qing_shu_ru_chong_zhi_shu_liang')"
							@input="handleAmountInput"
						>
						<div class="conversion-preview" v-if="isAutoExchangeRecharge">
							<div class="conversion-title">{{ i18n.t('recharge.auto_exchange_title', [conversionSourceName]) }}</div>
							<div class="conversion-text" v-if="conversionRateLoading">{{ i18n.t('recharge.auto_exchange_loading') }}</div>
							<template v-else>
								<div class="conversion-amount" v-if="conversionPreviewAmount">
									{{ i18n.t('recharge.auto_exchange_estimated') }}
									<span>{{ conversionPreviewAmount }} USDT</span>
								</div>
								<div class="conversion-text" v-else>{{ i18n.t('recharge.auto_exchange_input_tip') }}</div>
								<div class="conversion-text" v-if="conversionRate">
									{{ i18n.t('recharge.auto_exchange_rate', [conversionSourceName, formattedConversionRate]) }}
								</div>
								<div class="conversion-text warning" v-else>{{ i18n.t('recharge.auto_exchange_unavailable') }}</div>
								<div class="conversion-text">{{ i18n.t('recharge.auto_exchange_confirm_tip') }}</div>
							</template>
						</div>
					</div>
					<div class="form-btn">
						<button @click="submitRechargeApplication" :disabled="!isFormValid" :class="{'disabled': !isFormValid}">
							{{ i18n.t('recharge.ti_jiao_shen_qing') }}
						</button>
					</div>
				</div>
			</div>

			<div class="bottom-btn flex-center" v-show="false">
				<Button  class="plain" @click="toPath('kefu')">{{i18n.t('recharge.btn1')}}</Button>
				<Button class="copy-icon" @click="copyData">{{i18n.t('recharge.btn2')}}</Button>
			</div>
		</div>

     <!--充值类型-->
    <Popup v-model:show="showRecharge" position="bottom" lock-scroll class="rate-popup">
			<div class="rate-modal">
				<div class="title flex-center-between">
					<div>{{i18n.t('recharge.label5')}}</div>
					<img :src="closeUrl" alt="" @click="cancel">
				</div>
				<div class="recharge-list modal">
          <div class="list flex-center" v-for="(item, i) in filteredRechargeList" :key="i" @click="changeRecharge(item , i)" :class="rechargeInfoBak.name == item.name  ? 'active' : ''">
            <div class="icon">
              <img :src="item.icon" alt="">
            </div>
            <div class="name flex-1">
              <span>{{item.name}}</span>
            </div>
          </div>
				</div>

			</div>
		</Popup>
		

		

	</div>
</template>
<script>
import topBar from '@/components/topBar'
import { Popup, Button, Dialog } from 'vant'
import Clipboard from 'clipboard';
import QRCode from 'qrcodejs2'
import { rechargeAddress, applyPay, wallet } from '@/api/assest'
import { getExchangeRate } from '@/api/index'
import { saveAssets } from '@/api/setting'
import html2canvas from 'html2canvas'
import { getAssets } from '@/utils/auth'
import {
	calculateRechargeConversion,
	findRechargeConversionRate,
	protocolToShortName,
	shouldAutoExchangeRecharge
} from '@/utils/rechargeConversion'
export default {
	components: {
    Popup,
    Button,
		topBar,
		Dialog
  },
  data() {
		return {
			closeUrl: require('../../assets/imgs/icon-close.png'),
			copyUrl: require('../../assets/imgs/icon-copy.png'),
			backUrl: require('../../assets/imgs/icon-back.png'),
			rightUrl: require('../../assets/imgs/icon-arrow-down3.png'),
			logUrl: require('../../assets/imgs/icon-log.png'),
			    checkUrl: require('../../assets/imgs/icon-checked2.png'),
			showRecharge: false,
			showAccount: false,
			rechargeAddressData: {},
			accountName: '',
			filteredRechargeList: [],
      rechargeList: [
				{
					icon: require('../../assets/imgs/bit1.png'),
					name: 'USDT-TRC20',
					key: 'USDT-TRC20',
					min: 1
				},
				{
					icon: require('../../assets/imgs/bit1.png'),
					name: 'USDT-ERC20',
					key: 'USDT-ERC20',
					min: 1
				},
				{
					icon: require('../../assets/imgs/bit5.png'),
					name: 'USDC-TRC20',
					key: 'USDC-TRC20',
					min: 1
				},
				{
					icon: require('../../assets/imgs/bit5.png'),
					name: 'USDC-ERC20',
					key: 'USDC-ERC20',
					min: 1
				},
				{
					icon: require('../../assets/imgs/bit3.png'),
					name: 'ETH-ERC20',
					key: 'ETH-ERC20',
					min: 0.02
				},
				{
					icon: require('../../assets/imgs/bit4.png'),
					name: 'BTC',
					key: 'Bitcoin',
					min: 0.0002
				},
			],
			accountList: [
				{
					text: this.i18n.t('recharge.account1'),
					value: 'spot'
				},
				{
					text: this.i18n.t('recharge.account2'),
					value: 'option'
				},
				{
					text: this.i18n.t('recharge.account3'),
					value: 'contract'
				},
				{
					text: this.i18n.t('recharge.account4'),
					value: 'finance'
				},
			],
			rechargeInfo: {},
			rechargeInfoBak: {},
			address: '',
			addressData: {},
			conversionRate: null,
			conversionRateLoading: false,
			applyForm: {
				amount: ''
			},
		}
	},
	computed: {
		isFormValid() {
			const numericAmount = this.convertAmountToNumber(this.applyForm.amount);
			return numericAmount && this.address;
		},
		isAutoExchangeRecharge() {
			return shouldAutoExchangeRecharge(this.rechargeInfo.key);
		},
		conversionSourceName() {
			return protocolToShortName(this.rechargeInfo.key);
		},
		normalizedApplyAmount() {
			return this.convertAmountToNumber(this.applyForm.amount);
		},
		conversionPreviewAmount() {
			return calculateRechargeConversion(this.normalizedApplyAmount, this.conversionRate);
		},
		formattedConversionRate() {
			return this.conversionRate ? Number(this.conversionRate).toFixed(4) : '';
		}
	},
  mounted() {
		this.init()
		let type = this.$route.query.type || 'TRC20'
		let index = this.accountList.findIndex(v => {
			return v.value == getAssets()
		})
		if (index > -1) {
			this.accountName = this.accountList[index].text
		}
	},
	methods: {
		handleAmountInput(event) {
			const oldValue = this.applyForm.amount || '';
			let value = event.target.value;

			// 只允许数字、逗号和小数点，具体语义在提交时再转换
			value = value.replace(/[^0-9,\.]/g, '');

			// 不允许只输入一个分隔符作为开头
			if (value.length === 1 && (value === '.' || value === ',')) {
				value = '';
			}

			const hasComma = value.includes(',');
			const hasDot = value.includes('.');
			const dotCount = (value.match(/\./g) || []).length;
			const commaCount = (value.match(/,/g) || []).length;

			// 场景一：只有点，没有逗号时，点视为小数点，只允许一个
			if (!hasComma && dotCount > 1) {
				this.applyForm.amount = oldValue;
				event.target.value = oldValue;
				return;
			}

			// 场景二：只有逗号，没有点时，逗号既可能是小数点也可能是千分位
			// 允许多个逗号，但每一组长度最多 3 位，且仅包含数字，避免明显异常格式
			if (!hasDot && commaCount > 1) {
				const parts = value.split(',');
				let ok = true;
				for (let i = 0; i < parts.length; i++) {
					if (!/^\d*$/.test(parts[i])) {
						ok = false;
						break;
					}
					// 第一段 1~3 位，其余每段最多 3 位（用于兼容正在输入中的长金额）
					if (i === 0) {
						if (parts[i].length > 3) {
							ok = false;
							break;
						}
					} else {
						if (parts[i].length > 3) {
							ok = false;
							break;
						}
					}
				}
				if (!ok) {
					this.applyForm.amount = oldValue;
					event.target.value = oldValue;
					return;
				}
			}

			// 场景三：同时存在逗号和点，需要区分小数点和千分位
			if (hasComma && hasDot) {
				const lastComma = value.lastIndexOf(',');
				const lastDot = value.lastIndexOf('.');
				const decimalSep = lastComma > lastDot ? ',' : '.';
				const reg = new RegExp('\\' + decimalSep, 'g');
				const decCount = (value.match(reg) || []).length;
				// 小数分隔符只能出现一次，例如：禁止 1,231.12.123
				if (decCount > 1) {
					this.applyForm.amount = oldValue;
					event.target.value = oldValue;
					return;
				}
			}

			this.applyForm.amount = value;
		},
		// 将显示格式转换为数字格式（用于提交）
		convertAmountToNumber(amountStr) {
			if (!amountStr) return '';

			// 去掉空格，只保留数字、逗号和小数点
			let value = amountStr.replace(/\s/g, '').replace(/[^0-9,\.]/g, '');

			const hasComma = value.includes(',');
			const hasDot = value.includes('.');

			if (hasComma && hasDot) {
				// 同时存在逗号和小数点：
				// 先根据最后出现的位置判定小数分隔符，再校验千分位分组是否合法
				const lastComma = value.lastIndexOf(',');
				const lastDot = value.lastIndexOf('.');
				const decimalSep = lastComma > lastDot ? ',' : '.';
				const thousandSep = decimalSep === ',' ? '.' : ',';

				// 小数分隔符只能出现一次
				if (value.split(decimalSep).length > 2) {
					return '';
				}

				const partsByDecimal = value.split(decimalSep);
				const intPartRaw = partsByDecimal[0];
				const fracPartRaw = partsByDecimal[1] || '';

				// 校验整数部分千分位分组（如 12,345,678 或 1.234.567）
				let intDigits = intPartRaw;
				if (intPartRaw.includes(thousandSep)) {
					const segs = intPartRaw.split(thousandSep);
					// 第一段 1~3 位，其余必须是 3 位
					if (!segs[0] || segs[0].length > 3) {
						return '';
					}
					for (let i = 1; i < segs.length; i++) {
						if (segs[i].length !== 3) {
							return '';
						}
					}
					intDigits = segs.join('');
				}

				// 整数、小数部分都只能是数字
				if (!/^\d+$/.test(intDigits)) {
					return '';
				}
				if (fracPartRaw && !/^\d+$/.test(fracPartRaw)) {
					return '';
				}

				// 组装为统一的小数点格式，后面再统一限制最多 4 位小数
				value = intDigits + (fracPartRaw ? '.' + fracPartRaw : '');
			} else if (hasComma) {
				// 只有逗号时，根据分组判断是千分位还是小数点
				const parts = value.split(',');
				const allThree = parts.slice(1).every(p => p.length === 3);
				if (allThree && parts.length > 1 && parts[parts.length - 1].length === 3) {
					// 形如 1,234 或 1,234,567 => 逗号为千分位
					value = parts.join('');
				} else {
					// 形如 123,12 => 逗号为小数点
					value = value.replace(/,/g, '.');
				}
			} else if (hasDot) {
				// 只有小数点时，同样根据分组判断是否为千分位
				const parts = value.split('.');
				const allThree = parts.slice(1).every(p => p.length === 3);
				if (allThree && parts.length > 1 && parts[parts.length - 1].length === 3) {
					// 形如 1.234 或 1.234.567 => 点为千分位
					value = parts.join('');
				} else {
					// 常规小数点小数，保持不变
				}
			}

			// 现在只允许「数字」或「数字.数字」格式
			if (!/^\d+(\.\d+)?$/.test(value)) {
				return '';
			}

			// 限制最多 4 位小数，多余部分截断
			const parts = value.split('.');
			if (parts.length === 2 && parts[1].length > 4) {
				value = parts[0] + '.' + parts[1].substring(0, 4);
			}

			return value;
		},
		init() {
			rechargeAddress().then(res => {
				this.rechargeAddressData = res.data
				this.filteredRechargeList = this.rechargeList.filter(item => {
					return this.rechargeAddressData[item.key] && this.rechargeAddressData[item.key] !== '';
				});
				
				if (this.filteredRechargeList.length === 0) {
					this.filteredRechargeList = [...this.rechargeList];
				}
				
				if (this.filteredRechargeList.length > 0) {
					this.rechargeInfo = Object.assign({}, this.filteredRechargeList[0]);
					this.address = this.rechargeAddressData[this.rechargeInfo.key] || '';
					this.refreshRechargeConversionRate();
				}
				
				let qrcode = new QRCode(this.$refs.qrcode, {
					text: this.address,
					width: 120,
					height: 120,
					correctLevel: QRCode.CorrectLevel.H
				})
			})
	    },
		// 获取当前币种的警告提示
		getCurrentCurrencyWarning() {
			if (this.rechargeInfo && this.rechargeInfo.key) {
				return this.i18n.t(`recharge.warning_${this.rechargeInfo.key}`) || this.i18n.t('recharge.warning');
			}
			return this.i18n.t('recharge.warning');
		},
		back() {
			this.$router.go(-1)
		},
		toLog() {
			this.$router.push({
				name: 'assestLog',
				query: {
					type: 'recharge'
				}
			})
		},
		chooseRecharge() {
			this.rechargeInfoBak = Object.assign({}, this.rechargeInfo)
	     this.showRecharge = true
	   },
	   changeRecharge(data, i) {
			this.rechargeInfoBak = data
			this.submitChange()
	   },
		cancel() {
			this.showRecharge = false
		},
		copyData() {
	     let data = this.address
	     const clipboard = new Clipboard('.copy-icon', {text: () => data});
	     this.$toast.success(this.i18n.t('recharge.success'))
	   },
		submitChange() {
			this.rechargeInfo = Object.assign({}, this.rechargeInfoBak)
			this.address = this.rechargeAddressData[this.rechargeInfo.key] || '';
			this.refreshRechargeConversionRate();
			
			if (!this.address) {
				this.address = this.i18n.t('recharge.no_address');
			}
			
			document.getElementById('qrcode').innerHTML = ''
			let qrcode = new QRCode(this.$refs.qrcode, {
				text: this.address,
				width: 120,
				height: 120,
				correctLevel: QRCode.CorrectLevel.H
			})
			this.showRecharge = false
		},
		chooseAccount(data) {
			this.accountName = data.text
			let form = new FormData()
      form.append('Assets', data.value)
			saveAssets(form).then(res => {
				if (res.code == 0) {
          this.$toast.success(this.i18n.t('common.success'))
					this.showAccount = false
        } else {  
          this.$toast.fail(res.msg)
        }
			})
		},
		saveImg() {
			html2canvas(this.$refs.qrcode).then(canvas => {
				let a = document.createElement('a')
				a.href = canvas.toDataURL("image/png")
				a.download = `${this.i18n.t('recharge.img')}.png`
				var clickevent = document.createEvent('MouseEvents');
           clickevent.initEvent('click', true, false);
           a.dispatchEvent(clickevent);
			})
		},
		refreshRechargeConversionRate() {
			const protocol = this.rechargeInfo.key;
			if (!shouldAutoExchangeRecharge(protocol)) {
				this.conversionRate = null;
				this.conversionRateLoading = false;
				return;
			}

			this.conversionRateLoading = true;
			Promise.all([
				wallet({ current: 1, pageSize: 200 }),
				getExchangeRate({})
			]).then(([walletRes, tradeRes]) => {
				if (this.rechargeInfo.key !== protocol) return;

				const walletRows = walletRes.data && walletRes.data.Items ? walletRes.data.Items : [];
				const tradeRows = tradeRes.data || [];
				this.conversionRate = findRechargeConversionRate(protocol, walletRows, tradeRows);
			}).catch(err => {
				console.error('获取充值兑换汇率失败:', err);
				this.conversionRate = null;
			}).finally(() => {
				if (this.rechargeInfo.key === protocol) {
					this.conversionRateLoading = false;
				}
			});
		},
		toPath(path) {
			if (path) {
				this.$router.push({
					name: path
				})
			}
		},
			submitRechargeApplication() {
				// 表单验证
				if (!this.applyForm.amount) {
					this.$toast.fail(this.i18n.t('recharge.qing_shu_ru_chong_zhi_shu_liang'));
					return;
				}
				if (!this.address) {
					this.$toast.fail(this.i18n.t('recharge.qing_xuan_ze_bi_zhong'));
					return;
				}
	
				this.submitForm();
			},
			submitForm() {
				const formData = new FormData();
				// 将多种显示格式转换为统一数字格式后提交
				const numericAmount = this.convertAmountToNumber(this.applyForm.amount);
				if (!numericAmount) {
					this.$toast.fail(this.i18n.t('recharge.qing_shu_ru_chong_zhi_shu_liang'));
					return;
				}
				formData.append('Amount', numericAmount);
				formData.append('Address', this.address);
				formData.append('Name', this.rechargeInfo.key);
	
				// 使用API函数调用
				this.$toast.loading({
					message: this.i18n.t('recharge.submitting'),
					forbidClick: true,
				});
				
				// 使用applyPay API
				applyPay(formData)
					.then(response => {
						this.$toast.clear();
						if (response.code === 0) {
							this.$toast.success(this.i18n.t('recharge.ti_jiao_cheng_gong'));
							// 清空表单
							this.applyForm.amount = '';
						} else {
							this.$toast.fail(response.msg || this.i18n.t('recharge.ti_jiao_shi_bai'));
						}
					})
					.catch(error => {
						this.$toast.clear();
						console.error('Submit recharge application failed:', error);
						this.$toast.fail(error.message || this.i18n.t('recharge.ti_jiao_shi_bai'));
					});
			},
	}
}
</script>
<style scoped>
/* 添加充值申请表单样式 */
.recharge-application {
  margin-top: 20px;
  background-color: var(--bg-color, #fff);
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.application-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
  color: var(--text-color, #333);
  border-left: 4px solid var(--primary-color, #1989fa);
  padding-left: 10px;
}

.form-content {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.form-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-item .label {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-color, #333);
}

.required {
  color: #f44;
  margin-left: 3px;
}

.form-item input {
  height: 44px;
  border-radius: 8px;
  border: 1px solid var(--border-color, #dcdee0);
  background: var(--input-bg, #fff);
  padding: 0 15px;
  font-size: 14px;
  color: var(--text-color, #333);
  transition: border-color 0.3s;
}

.form-item input:focus {
  border-color: var(--primary-color, #1989fa);
  outline: none;
}

.conversion-preview {
  border-radius: 8px;
  background: rgba(25, 137, 250, 0.08);
  border: 1px solid rgba(25, 137, 250, 0.18);
  padding: 12px;
  color: var(--text-color, #333);
}

.conversion-title {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
}

.conversion-amount {
  font-size: 13px;
  line-height: 1.5;
}

.conversion-amount span {
  color: var(--primary-color, #1989fa);
  font-weight: 700;
}

.conversion-text {
  font-size: 12px;
  line-height: 1.5;
  color: #666;
}

.conversion-text.warning {
  color: #d46b08;
}



.form-btn {
  margin-top: 10px;
}

.form-btn button {
  width: 100%;
  height: 44px;
  background-color: var(--primary-color, #1989fa);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.3s;
}

.form-btn button:hover {
  opacity: 0.9;
}

.form-btn button.disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

</style>
